let DesignTabs = function (props) {
  let { selected, onSelect } = props;

  return (
    <div className="rc-design-tabs">
      {["SUPERVISED", "UNSUPERVISED"].map(function (tab) {
        return (
          <button
            key={tab}
            aria-pressed={selected === tab}
            data-supervision-mode={tab}
            onClick={() => onSelect(tab)}>
              <img src={"./img/rc/tab." + tab + ".svg"} width="60" height="42"/>
              <span>{tx("mode." + tab)}</span>
          </button>
        );
      })}
    </div>
  );
};

module.exports = DesignTabs;